import { type ColorVariant } from "@/constants/theme";
import { useCoreTheme } from "@/context/coreTheme";
import { getHEXColorByColorVariant } from "@/utils/style/getHEXColorByColorVariant";

export function useGetHEXColorByColorVariant(colorVariant: ColorVariant) {
  const theme = useCoreTheme();

  return getHEXColorByColorVariant(theme, colorVariant);
}
